const BASE_FONT_SIZE = 16 / 12;

export const fontByZoom = (zoom: number) => {
    return BASE_FONT_SIZE * (1 / zoom) + 'rem';
};

export const fontSelector = (s: { transform: number[] }) => {
    return fontByZoom(s.transform[2]);
};
